import { render, staticRenderFns } from "./TsDisplayCurrency.vue?vue&type=template&id=a3b61684&"
import script from "./TsDisplayCurrency.vue?vue&type=script&lang=js&"
export * from "./TsDisplayCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports